'use strict';
import * as $j_com$002eraquo$002eairstream$002eownership$002e$002dDynamic$002dSubscription$0024 from "./com.raquo.airstream.ownership.-Dynamic-Subscription$.js";
import * as $j_com$002eraquo$002elaminar$002einserters$002e$002dInsert$002dContext$0024 from "./com.raquo.laminar.inserters.-Insert-Context$.js";
import * as $j_com$002eraquo$002elaminar$002elifecycle$002e$002dMount$002dContext from "./com.raquo.laminar.lifecycle.-Mount-Context.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1 from "./scala.scalajs.runtime.-Anon-Function1.$$-Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_inserters_DynamicInserter(initialContext, preferStrictMode, insertFn, hooks) {
  this.GM = null;
  this.GO = false;
  this.GN = null;
  this.z0 = null;
  this.GM = initialContext;
  this.GO = preferStrictMode;
  this.GN = insertFn;
  this.z0 = hooks;
}
export { $c_Lcom_raquo_laminar_inserters_DynamicInserter as $c_Lcom_raquo_laminar_inserters_DynamicInserter };
$p = $c_Lcom_raquo_laminar_inserters_DynamicInserter.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_inserters_DynamicInserter;
/** @constructor */
function $h_Lcom_raquo_laminar_inserters_DynamicInserter() {
}
export { $h_Lcom_raquo_laminar_inserters_DynamicInserter as $h_Lcom_raquo_laminar_inserters_DynamicInserter };
$h_Lcom_raquo_laminar_inserters_DynamicInserter.prototype = $p;
$p.u1 = (function(element) {
  var this$1 = this.GM;
  var insertContext = (this$1.k() ? $j_com$002eraquo$002elaminar$002einserters$002e$002dInsert$002dContext$0024.$m_Lcom_raquo_laminar_inserters_InsertContext$().X4(element, this.GO, this.z0) : this$1.C());
  var subscribe = new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((mountContext) => this.GN.jj(insertContext, mountContext.z7, this.z0)));
  return $j_com$002eraquo$002eairstream$002eownership$002e$002dDynamic$002dSubscription$0024.$m_Lcom_raquo_airstream_ownership_DynamicSubscription$().rr(element.fs, new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((owner) => subscribe.j(new $j_com$002eraquo$002elaminar$002elifecycle$002e$002dMount$002dContext.$c_Lcom_raquo_laminar_lifecycle_MountContext(element, owner)))), false);
});
$p.dL = (function(element) {
  this.u1(element);
});
var $d_Lcom_raquo_laminar_inserters_DynamicInserter = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_inserters_DynamicInserter, "com.raquo.laminar.inserters.DynamicInserter", ({
  i8: 1,
  ab: 1,
  ic: 1,
  i9: 1
}));
export { $d_Lcom_raquo_laminar_inserters_DynamicInserter as $d_Lcom_raquo_laminar_inserters_DynamicInserter };
